import * as reduxModule from "redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "redux/reducers/index";
/* eslint no-underscore-dangle: 0 */
reduxModule.__DO_NOT_USE__ActionTypes.REPLACE = "@@redux/INIT";

const composeEnhancers =
  process.env.NODE_ENV !== "production" &&
  typeof window === "object" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const logger = () => (next) => (action) => next(action);

const enhancer = composeEnhancers(applyMiddleware(logger, thunk));

const store = createStore(rootReducer, enhancer);

export default store;
